import {useCallback} from 'react';

import DocumentActions from 'notebook/documents/DocumentActions';
import DocumentStore from 'notebook/documents/DocumentStore';
import {RealtimeMessageType} from 'realtime/Constants';
import {RealtimeMessage} from 'realtime/RealtimeChannel';
import useRealtimeChannelSubscription from 'realtime/useRealtimeChannelSubscription';
import {getRealtimeChannelNameForApiId} from 'realtime/util/RealtimeUtil';

/**
 * Marks specific step documents as stale when the backend reports that their
 * content was updated (e.g. after process intermediate table regeneration).
 *
 * Skips the active document because the per-document ENTRY_UPDATE handler
 * already refreshes it
 */
export function useWorksheetDocumentUpdates(worksheetId: string, activeDocumentId: string | undefined): void {
  const onMessage = useCallback(
    (message: RealtimeMessage) => {
      if (message.name === RealtimeMessageType.WORKSHEET_DOCUMENTS_UPDATED) {
        const {updatedDocumentIds} = message.data;
        for (const docId of updatedDocumentIds) {
          if (docId !== activeDocumentId && DocumentStore.inStore(docId)) {
            DocumentActions.postServerUpdate(docId, {isStale: true});
          }
        }
      }
    },
    [activeDocumentId]
  );

  useRealtimeChannelSubscription(getRealtimeChannelNameForApiId(worksheetId), onMessage, [
    RealtimeMessageType.WORKSHEET_DOCUMENTS_UPDATED,
  ]);
}
